export default "__VITE_ASSET__70ac17e0__"